
  
  <div  class="outside-container mt-4">

            <div class="box-container ">
              <div class="container">
                  <div class="title ">
        
                    <div class="row">
                      <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
                     <div class="col-md-7 d-flex justify-content-center">Content Management</div>
                     <div class=" col-md-3 row ">
                       <div class="d-flex justify-content-end">
                       
                     </div>
                      </div>
                    </div>
                  
                  </div> 
                  </div>
                  </div>
                  </div>
          <div  class="outside-container ">
                <div class="box-container ">
                    <div class="container ">
                      <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                        <div class="col-md-2  " [ngStyle]="{'background-color':color?.sideBarColor}" style=" border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                          <div class="col-md-12 ">
                            <!-- <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickGeneral()" [ngClass]="{'activity' :showGeneralConfig}">Notifications</span></span>  -->

                          <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns" >Notifications</span></span> 
                          <!-- <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px" (click)="logoClick()"> <span class=" btns" >Logos</span></span>  -->
                      
                      </div>
                          
                        </div>
                        
                       <div class="col-md-10" style="height:70vh; overflow-y: auto;">


                        <div *ngIf="showLogo" class="col-md-12 card" style="min-height: 100%;" >
    <!-- <app-corporate-logo></app-corporate-logo> -->
                          </div>







                         <div *ngIf="showGroup" class="col-md-12 card" style="min-height: 100%;" >
    
                          <div class=" row mt-3 " style="padding: 10px;">
                           
                            
                            <div class="col-md-12 " >
                              <div class="row">
                              <mat-form-field class=" col-md-3 mt-1 form-group " >
                              <input matInput type="text"  [(ngModel)]="search.searchText"    placeholder="Search..." autocomplete="off" (input)="searchUser()"  >
                              
                              </mat-form-field>
                              <div  class="  col-md-1 pt-3">
                                  <button  class="btn btn-outline-primary btn-sm " (click)="onAddGroup()"><img src="assets/images/Add_24.png"></button>
                                 
                               </div>
                              <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
                              [pageSize]="10"
                              [pageSizeOptions]="[5, 10, 25, 100]"
                              [length]="totalElements"
                              (page)="nextPage($event)"
                              aria-label="Select page">
                              </mat-paginator>
                              
                              </div>
                              
                              <table mat-table
                              [dataSource]="groupData" multiTemplateDataRows style="background-color: transparent;">
                             
                              <!-- <ng-container matColumnDef="code">
                               <th mat-header-cell *matHeaderCellDef> Code </th>
                               <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
                              </ng-container> -->
                               <ng-container matColumnDef="name">
                                 <th mat-header-cell *matHeaderCellDef>Name</th>
                                 <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowGroupClick(element)"> {{element.name}} </td>
                               </ng-container>
                               <ng-container matColumnDef="source">
                                  <th mat-header-cell *matHeaderCellDef>Source</th>
                                  <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);"> {{sourceCodeToName(element.source)}} </td>
                                </ng-container>
    
                              <ng-container matColumnDef="status">
                               <th mat-header-cell *matHeaderCellDef> Status </th>
                               <td mat-cell *matCellDef="let element"> 
                                <span *ngIf="element.status==='A'">Active</span>
                                <span *ngIf="element.status==='I'">Inactive</span> </td>
                              </ng-container>
                              
                              <!-- email Column -->
                             
                              <ng-container matColumnDef="creationDate" >
                                <th mat-header-cell *matHeaderCellDef>Creation Date</th>
                                <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                               </ng-container>
  
                               <ng-container matColumnDef="delete" >
                                  <th mat-header-cell *matHeaderCellDef>Action </th>
                                  <td mat-cell *matCellDef="let element"> <img (click)="deleteQueue(element.id)"  src="../../../assets/images/crosss.png" style="width: 25px;cursor: pointer;" alt=""> </td>
                                 </ng-container>
                             
                              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                              <ng-container matColumnDef="expandedDetail">
                              <td mat-cell *matCellDef="let element" [attr.colspan]="columnsGroupDisplay.length">
                              <div class="example-element-detail row"
                               [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                              
                              </div>
                              </td>
                              </ng-container>
                              
                              <tr mat-header-row *matHeaderRowDef="columnsGroupDisplay"></tr>
                              <tr mat-row *matRowDef="let element; columns: columnsGroupDisplay;"
                              class="example-element-row">
                              </tr>
                              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                              <tr class="mat-row" *matNoDataRow>
                              <td  class="mat-cell" colspan="4">There is no data in this table</td>
                              </tr>
                              </table>
                              
                              
                              </div>
                              
                          
                        
                        </div> 
                          </div>
                          
                        </div>
                        </div>
                    </div>
    
                    <div class="modal " id="myMod"  [style.display]="showGroupPopup ? 'block' : 'none'" >
                      <div class="modal-dialog" >
                          <div class="modal-content " >
                              <div class="modal-header title">
                                <h4  *ngIf="action==='newQue'" class="modal-title">Add </h4>
                                <h4  *ngIf="action!='newQue'" class="modal-title">View </h4>

                                <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                                </div>
                                <div class="modal-body">
                                <div class="col-md-12 mt-3 " *ngIf="showGroupPopup">
                                  <div class="col-md-12 d-flex justify-content-center" >
                                  <div class="col-md-12 row " >
                                      <div class=" col-md-12 ">
                                          <form [formGroup]="queueRegFg"  autocomplete="off"  class=" row" >
                                            
                                            <mat-form-field class="col-md-12" appearance="outline">
                                              <mat-label> Name</mat-label>
                                              <input matInput type="text" maxlength="30"  formControlName="name" name="name" autocomplete="off">
                                              <small *ngIf="queueRegFg.controls['name'].dirty && queueRegFg.controls['name'].invalid" class="warn">Please Enter Queue name!</small>
    
                                            </mat-form-field>
                                              <mat-form-field  class="col-md-12" appearance="outline">
          <mat-label>Users  </mat-label>
          <mat-select-trigger (click)="autoBill.open()">
            <input (input)="autoBill.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEntities()" />
          </mat-select-trigger>
          <mat-select #autoBill="matSelect" multiple formControlName="userUid" (selectionChange)="onChangeUsers()"  matNativeControl  name="entity" required >
            <mat-option *ngFor="let item of filteredEntities"     [value]="item?.userUid" >{{ item.name }} {{item.username}} ({{ item.userType }})</mat-option>
          </mat-select>
  
        </mat-form-field> 
                                          
<!--                                             
                                            <mat-form-field class="col-md-12" appearance="outline">
                                              <mat-label>Status</mat-label>
                                              <mat-select matNativeControl name="status" formControlName="status">
                                                <mat-option value="A">Active</mat-option>
                                                <mat-option value="I">Inactive</mat-option>
                                              </mat-select>  
                                            </mat-form-field>  -->
                                        <div *ngIf="action==='newQue'" class="col-md-12 mb-2">
                                            <input class="form-control" type="file" accept=".docx,image/*" (change)="onFileSelecteds($event)">
                                        </div>
                                        <span class="file-types-msg">
                                         Acceptable file types: .docx,images*
                                         </span>
                                        <div *ngIf="htmlContent" class="tab-content ">
                                            <div style="margin-top: 20px;">
                                                <div [innerHTML]="htmlContent" style="border: 1px solid #ff9933;border-radius: 4px; padding: 10px;text-align: start;background-color: transparent;font-family:Courier New"></div>
                                              </div>
                                        </div>  

                                            
                                            </form>
                                      </div>
                                      </div>
                                      </div>                                      
                                </div>
                                  <div class="modal-footer">
                                    <div class="form-group form-inline ">
                                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                    </div>   
                                    <button *ngIf="action==='newQue'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddQueue()" [disabled]="queueRegFg.invalid">Save</button>

                                    
                                    <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                                  </div>
                                </div>
                                </div>
                        </div>
                    </div>
                    

                    